import script from "./tableBox.vue?vue&type=script&setup=true&lang=ts"
export * from "./tableBox.vue?vue&type=script&setup=true&lang=ts"

import "./tableBox.vue?vue&type=style&index=0&id=32c3ea70&lang=scss&scoped=true"

import exportComponent from "/root/workspace/dec_website_mQOS/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32c3ea70"]])

export default __exports__